module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-editor', {
    attrs: {
      "useCustomImageHandler": ""
    },
    on: {
      "imageAdded": _vm.handleImageAdded
    },
    model: {
      value: (_vm.editor.content),
      callback: function($$v) {
        _vm.$set(_vm.editor, "content", $$v)
      },
      expression: "editor.content"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bfe28ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/components/Editor.vue
// module id = 904
// module chunks = 0